<template>
  <div :class="['live-page', passWaxWidth ? 'max-page-width' : '']">
    <jump-header />
    <div :class="['live-detail', passWaxWidth ? 'max-page-width' : '']">
      <div class="content-wrapper">
        <div
          class="img-wrapper"
          :style="{ height: passWaxWidth ? '100%' : '280px' }"
        >
          <div class="tag-wrapper">
            <div class="tag">
              {{ playType !== "playRecord" ? "直播" : "回听" }}
            </div>
            <playing-icon
              v-if="playType !== 'playRecord'"
              class="tag-loading"
            />
          </div>
          <img class="holder-img" :src="programInfo.pictureUrl" />
          <img class="radio-img" :src="programInfo.radioStationPictureUrl" />
          <div class="click-sum-wrapper">
            <i class="v-icon-play-small" size="10px" />
            <span>{{ programInfo.clickSum }}</span>
          </div>
        </div>
        <div class="progress-wrapper">
          <van-progress
            v-if="playType !== 'playRecord'"
            :pivot-text="showBarInfo"
            :stroke-width="2"
            pivot-color="#FFFEFE"
            text-color="black"
            track-color="#7F868F"
            color="#fff"
            :percentage="percentage"
          />
          <div class="slider-wrapper" v-else>
            <div class="slider-currentTime">{{ playRecordStartTime }}</div>
            <van-slider
              v-model="recordProcess"
              bar-height="3px"
              inactive-color="#7F868F"
              active-color="#FFFEFE"
              @change="onChangeSlider"
              @drag-start="dragStart"
              @update:model-value="sliderModelValue"
            >
              <template #button>
                <div class="progress-bar-btn">{{ recordProcess }}%</div>
              </template>
            </van-slider>
            <div class="slider-duratrion">{{ playRecordEndTime }}</div>
          </div>
        </div>
        <div class="options-wrapper">
          <div class="options-wrapper-btn" @click="toSevenDaysRecord">
            <i class="v-icon-list" size="22px" />
          </div>
          <div
            :class="[
              'options-wrapper-btn',
              playType !== 'playRecord' ? 'options-wrapper-btn-living' : '',
            ]"
          >
            <i class="v-icon-play-prev" size="22px" />
          </div>
          <div class="options-wrapper-btn" @click.stop.prevent="changePlay">
            <i :class="playStatus" size="58px" />
            <canvas
              v-show="showCanvasLoading"
              id="canvas"
              width="60"
              height="60"
            />
          </div>
          <div
            :class="[
              'options-wrapper-btn',
              playType !== 'playRecord' ? 'options-wrapper-btn-living' : '',
            ]"
          >
            <i class="v-icon-play-next" size="22px" />
          </div>
          <div class="options-wrapper-btn">
            <i class="v-icon-appoinment" size="26px" />
          </div>
        </div>
      </div>
    </div>
    <div class="popup-wrapper" :style="popupWrapperStyle" ref="popupWrapperRef">
      <div ref="popupHeaderRef">
        <div>
          <div class="popup-holder"></div>
          <van-swipe
            class="notice-swipe"
            vertical
            :show-indicators="false"
            :touchable="false"
            :autoplay="5000"
          >
            <van-swipe-item v-for="(item, index) in anchorList" :key="index">
              <div class="popup-info">
                <img class="radio-avatar" :src="item.publicImage" alt="" />
                <div class="right-content">
                  <span class="content-name">{{ item.nickname }}</span>
                  <span class="content-program text-line-1">{{
                    item.intro
                  }}</span>
                </div>
                <div
                  :class="[
                    'right-focus',
                    item.isCare ? 'right-focus-active' : '',
                  ]"
                  @click="showDownloadAppToast"
                >
                  <i v-if="!item.isCare" class="v-icon-cha right-focus-icon" />
                  <span>关注</span>
                </div>
              </div>
            </van-swipe-item>
          </van-swipe>
        </div>
        <div class="popup-item-wrapper" ref="popupItemWrapperRef">
          <div
            class="popup-item"
            v-for="(item, index) in popupItemList"
            :key="index"
            @click="changeTab(index)"
          >
            <div
              :class="[
                'popup-item-name',
                currentItemIndex === index ? 'popup-item-name-active' : '',
              ]"
            >
              {{ item }}
            </div>
          </div>
          <div class="popup-item-solid" :style="popupItemSolid"></div>
        </div>
      </div>
      <scroll
        :probeType="3"
        :pullUpLoad="true"
        class="popup-content"
        ref="popupContentRef"
      >
        <!-- @isPullingUp="isPullingUp" -->
        <transition :name="transitionName">
          <!-- 避免组件多次渲染 -->
          <keep-alive>
            <component
              :is="isComponent"
              :programId="programInfo.id"
              :programCode="programInfo.programCode"
              :radioStationCode="programInfo.radioStationCode"
              @playRecord="playRecord"
            ></component>
          </keep-alive>
        </transition>
      </scroll>
    </div>
    <!-- 直播流播放 -->
    <video ref="videoRef"></video>
    <!-- 回听播放 -->
    <audio
      ref="audioRef"
      @timeupdate="timeUpdate"
      @canplay="audioCanPlay"
    ></audio>
  </div>
</template>

<script>
import Hls from "hls.js";
import { Dialog, Toast } from "vant";
import wxSdk from "@/http/wxApi.js";
import { useRoute, useRouter } from "vue-router";
import Scroll from "@/components/Scroll/Scroll";
import JumpHeader from "@/components/Base/JumpHeader";
import PlayingIcon from "@/components/Base/PlayingIcon";
import LivingRecord from "@/components/LivingComponents/LivingRecord";
import LivingComment from "@/components/LivingComponents/LivingComment";
import LivingProgram from "@/components/LivingComponents/LivingProgram";
import { defineComponent, onMounted, ref } from "vue";
import {
  selectCurrentLivingProgramByCode,
  getProgramHostInfos,
  selectProgramById,
  getProgramReplayInfos,
} from "@/http/api.js";

export default defineComponent({
  name: "LivingDetail",
  components: {
    Scroll,
    JumpHeader,
    PlayingIcon,
    LivingRecord,
    LivingProgram,
    LivingComment,
  },
  setup() {
    const route = useRoute();
    const router = useRouter();
    const hls = ref(null);
    const duration = ref(0);
    const playType = ref("");
    const percentage = ref(0);
    const audioRef = ref(null);
    const videoRef = ref(null);
    const anchorList = ref([]);
    const programInfo = ref({});
    const recordProcess = ref(0);
    const passWaxWidth = ref(false);
    const showCanvasLoading = ref(false);
    const showBarInfo = ref("00:00/23:59");
    const playRecordEndTime = ref("00:00");
    const playRecordStartTime = ref("00:00");
    const playStatus = ref("v-icon-pause-circle");
    let livingTimer = null;
    let debounceCount = 5;
    let sec = 0;
    let isDrag = false;
    let currentSec = -1;
    let timer = null;
    console.log(route.query.programId);

    const { ...useTabLogicProps } = useTabLogic();
    const { ...usePopupWrapperLogicProps } = usePopupWrapperLogic();

    function changePlay() {
      if (playStatus.value === "v-icon-pause-circle") {
        playStatus.value = "v-icon-play-circle";
        if (playType.value === "living") {
          getStream(programInfo.value.programFile, false);
        } else {
          audioRef.value.pause();
        }
      } else {
        playStatus.value = "v-icon-pause-circle";
        if (playType.value === "living") {
          getStream(programInfo.value.programFile, true);
        } else {
          audioRef.value.play();
        }
      }
    }

    function onChangeSlider(value) {
      console.log(value);
      isDrag = true;
      let currentTimeSec = Math.floor((value * audioRef.value.duration) / 100);
      audioRef.value.currentTime = currentTimeSec;
      const currentTimeFmt = useDateFormat(currentTimeSec);
      playRecordStartTime.value = `${currentTimeFmt.min}:${currentTimeFmt.sec}`;
      setTimeout(() => {
        isDrag = false;
      }, 100);
    }

    function dragStart() {
      // isDrag.value = true;
    }

    function sliderModelValue(value) {
      console.log(value);
    }

    function toSevenDaysRecord() {
      router.push({
        name: "SevenDaysRecord",
        query: {
          radioStationCode: programInfo.value.radioStationCode,
        },
      });
    }

    const add0 = (val) => {
      return val < 10 ? `0${val}` : val;
    };

    const getDurationInfo = () => {
      const date = new Date();
      let hours = date.getHours();
      let mins = add0(date.getMinutes());
      let secs = add0(date.getSeconds());
      let showNow = `${hours}:${mins}:${secs}`;
      // 节流操作
      if (debounceCount === 5) {
        let curPlayTime =
          parseInt(secs) + parseInt(mins * 60) + parseInt(hours * 60 * 60);
        let sts = programInfo.value.startTime.split(":");
        let stss = sts[0] * 60 * 60 + sts[1] * 60;
        curPlayTime = curPlayTime - stss;
        let ends = [];
        ends = programInfo.value.endTime.split(":");
        let endss = ends[0] * 60 * 60 + ends[1] * 60;
        let timeTotal = endss - stss;
        if (timeTotal != 0) {
          percentage.value = parseInt((curPlayTime / timeTotal) * 100);
          if (percentage.value > 100) {
            percentage.value = 100;
          }
        }
        debounceCount = 0;
      } else {
        debounceCount += 1;
      }
      showBarInfo.value = `${showNow}/${programInfo.value.endTime}:00`;
    };

    const getProgramInfo = async () => {
      const { data } = await selectCurrentLivingProgramByCode({
        code: route.query.code,
      });
      console.log(data);
      if (data.code === 1) {
        programInfo.value = data.data;
        programInfo.value.clickSum = fixNumToBig(data.data.clickSum);
        Dialog.confirm({
          title: "节目正在直播，是否收听",
        })
          .then(() => {
            // on confirm
            getStream(data.data.programFile, true);
            livingTimer = setInterval(() => {
              getDurationInfo();
            }, 990);
          })
          .catch(() => {
            // on cancel
          });
      }
    };

    const getRecordProgramInfo = async () => {
      const { data } = await selectProgramById({
        id: route.query.programId,
      });
      if (data.code == 1) {
        programInfo.value = data.data;
        programInfo.value.clickSum = fixNumToBig(data.data.clickSum);
        getRecordList();
      }
    };

    const getRecordList = async () => {
      const { code, data } = await getProgramReplayInfos({
        programCode: programInfo.value.programCode,
        playDays: 8,
        radioStationCode: programInfo.value.radioStationCode,
      });
      if (code === "1") {
        programInfo.value.radioStationPictureUrl = programInfo.value.pictureUrl;
        playRecord(data[0], 1);
      }
    };

    const playRecord = (item, type = 0) => {
      console.log(item);
      playType.value = "playRecord";
      if (type === 0) {
        getStream(programInfo.value.programFile, false);
      }
      audioRef.value.src = item.programFile;
      audioRef.value.play();
    };

    const useDateFormat = (sec) => {
      const min = Math.floor(sec / 60);
      sec = Math.floor(sec % 60);
      return {
        min: _parse0(min),
        sec: _parse0(sec),
      };
    };

    const _parse0 = (sec) => {
      return sec < 10 ? `0${sec}` : sec;
    };

    const audioCanPlay = () => {
      const currentTimeFmt = useDateFormat(audioRef.value.duration);
      playRecordEndTime.value = `${currentTimeFmt.min}:${currentTimeFmt.sec}`;
    };

    const timeUpdate = (val) => {
      let currentTimeTemp = audioRef.value.currentTime;
      // 节流操作
      sec = currentTimeTemp.toString().split(".")[0];
      if (sec != currentSec) {
        const currentTimeFmt = useDateFormat(currentTimeTemp);
        playRecordStartTime.value = `${currentTimeFmt.min}:${currentTimeFmt.sec}`;
        currentSec = sec;
        if (!isDrag) {
          recordProcess.value = Math.floor(
            (sec / audioRef.value.duration) * 100
          );
        }
      }
    };

    const getStream = (source, status) => {
      if (Hls.isSupported()) {
        hls.value = new Hls();
        hls.value.loadSource(source);
        hls.value.attachMedia(videoRef.value);

        hls.value.on(Hls.Events.MANIFEST_PARSED, () => {
          // console.log("加载成功");
          if (status) {
            videoRef.value.play();
          } else {
            videoRef.value.pause();
          }
        });
        hls.value.on(Hls.Events.ERROR, (event, data) => {
          // console.log(event, data);
          // 监听出错事件
          // console.log("加载失败");
        });
      } else if (videoRef.value.canPlayType("application/vnd.apple.mpegurl")) {
        videoRef.value.src = source;
        videoRef.value.addEventListener("loadedmetadata", () => {
          if (status) {
            videoRef.value.play();
          } else {
            videoRef.value.pause();
          }
        });
      }
    };

    const showDownloadAppToast = () => {
      Toast.fail("请先下载APP");
    };

    const getProgramAnchorList = async () => {
      const result = await getProgramHostInfos({
        programCode: programInfo.value.programCode,
        radioStationCode: programInfo.value.radioStationCode,
      });
      console.log("ccccccccccc");
      console.log(result);
      if (result.code === "1") {
        anchorList.value = result.data;
      }
    };

    function fixNumToBig(val) {
      if (val > 10000) {
        return `${(val / 10000).toFixed(2)}万`;
      }
      return val;
    }

    const resizeHook = () => {
      window.addEventListener("resize", (e) => {
        if (timer) {
          return;
        }
        timer = setTimeout(() => {
          let innerWidth = window.innerWidth;
          if (innerWidth > 450) {
            passWaxWidth.value = true;
          } else {
            passWaxWidth.value = false;
          }
          clearTimeout(timer);
        }, 300);
      });
    };

    const init = async () => {
      playType.value = "living";
      if (route.query.playType) {
        await getRecordProgramInfo();
      } else {
        await getProgramInfo();
      }
      await getProgramAnchorList();
      resizeHook();
      wxShare();
    };

    const wxShare = () => {
      const _programInfo = programInfo.value;
      wxSdk.getJSSDK({
        title: _programInfo.name,
        desc: _programInfo.radioStationName,
        linkurl: `https://app.gztv.com/hcfmshare/#/LivingDetail?code=${_programInfo.radioStationCode}&programId=${_programInfo.id}`,
        img: _programInfo.pictureUrl,
      });
    };

    onMounted(() => {
      let innerWidth = window.innerWidth;
      if (innerWidth > 450) {
        passWaxWidth.value = true;
      }
      init();
    });

    return {
      playType,
      videoRef,
      audioRef,
      playStatus,
      percentage,
      anchorList,
      programInfo,
      showBarInfo,
      passWaxWidth,
      recordProcess,
      showCanvasLoading,
      playRecordEndTime,
      playRecordStartTime,
      showDownloadAppToast,
      dragStart,
      timeUpdate,
      playRecord,
      changePlay,
      audioCanPlay,
      onChangeSlider,
      sliderModelValue,
      toSevenDaysRecord,
      ...useTabLogicProps,
      ...usePopupWrapperLogicProps,
    };
  },
});

const useTabLogic = () => {
  const currentItemIndex = ref(0);
  const popupItemWrapperWidth = ref(0);
  const popupItemWrapperRef = ref(null);
  const transitionName = ref("fold-left");
  const isComponent = ref("LivingProgram");
  const popupItemList = ["电台", "讨论区", "直播间", "7日回听"];
  const popupItemSolid = ref({
    transform: "",
  });
  const componentList = [
    "LivingProgram",
    "LivingComment",
    "liveInteract",
    "LivingRecord",
  ];

  function changeTab(index) {
    if (index === 2) {
      Toast.fail("该功能仅APP端支持，请先下载APP");
      return;
    }
    const _currentItemIndex = currentItemIndex.value;
    if (_currentItemIndex === index) {
      return;
    }
    popupItemSolid.value.transform = `translateX(calc(${
      ((0.5 + index) * popupItemWrapperWidth.value) / 4
    }px - 10px))`;
    if (_currentItemIndex < index) {
      transitionName.value = "fold-left";
    } else {
      transitionName.value = "fold-right";
    }
    currentItemIndex.value = index;
    isComponent.value = componentList[index];
  }

  const resizeHook = () => {
    window.addEventListener("resize", (e) => {
      popupItemWrapperWidth.value = popupItemWrapperRef.value.offsetWidth
        ? popupItemWrapperRef.value.offsetWidth
        : popupItemWrapperWidth.value;
      popupItemSolid.value.transform = `translateX(calc(${
        ((0.5 + 0) * popupItemWrapperWidth.value) / 4
      }px - 10px))`;
    });
  };

  onMounted(() => {
    popupItemWrapperWidth.value = popupItemWrapperRef.value.offsetWidth;
    popupItemSolid.value.transform = `translateX(calc(${
      ((0.5 + 0) * popupItemWrapperWidth.value) / 4
    }px - 10px))`;
    resizeHook();
  });

  return {
    isComponent,
    popupItemList,
    popupItemSolid,
    transitionName,
    currentItemIndex,
    popupItemWrapperRef,
    changeTab,
  };
};

const usePopupWrapperLogic = () => {
  const MAX_TOP = ref(0);
  const translateYVal = ref(0);
  const popupHeaderRef = ref(null);
  const popupWrapperRef = ref(null);
  const popupContentRef = ref(null);
  const popupWrapperStyle = ref({
    top: "125px",
    transform: "translateY(0)",
    transition: "all 0s ease-in-out",
  });
  let distanceY = 0;
  let startY = 0;
  let isMouseDown = false;

  const touchStart = (e) => {
    distanceY = 0;
    startY = e.touches[0].pageY;
    translateYVal.value = parseInt(
      popupWrapperStyle.value.transform.substring(11).replace(/px\)/g, "")
    );
  };

  const touchMove = (e) => {
    e.preventDefault();
    const _translateYVal = translateYVal.value;
    distanceY = e.touches[0].pageY - startY;
    // 上移
    if (distanceY < 0) {
      if (_translateYVal > -10 && _translateYVal < 10) {
        return;
      }
      if (distanceY + _translateYVal < 0) {
        return;
      }
      popupWrapperStyle.value.transform = `translateY(${
        _translateYVal + distanceY
      }px)`;
    }
    // 下移
    if (distanceY > 0) {
      if (_translateYVal > MAX_TOP - 91) {
        return;
      }
      if (distanceY + _translateYVal > MAX_TOP - 91) {
        return;
      }
      popupWrapperStyle.value.transform = `translateY(${
        _translateYVal + distanceY
      }px)`;
    }
  };

  const touchEnd = () => {
    if (distanceY > 0) {
      bodyDown();
    } else {
      bodyGrow();
    }
    distanceY = 0;
  };

  const mouseDown = (e) => {
    isMouseDown = true;
    distanceY = 0;
    startY = e.pageY;
    translateYVal.value = parseInt(
      popupWrapperStyle.value.transform.substring(11).replace(/px\)/g, "")
    );
  };

  const mouseMove = (e) => {
    if (isMouseDown) {
      const _translateYVal = translateYVal.value;
      distanceY = e.pageY - startY;
      // 上移
      if (distanceY < 0) {
        if (_translateYVal > -10 && _translateYVal < 10) {
          return;
        }
        if (distanceY + _translateYVal < 0) {
          return;
        }
        popupWrapperStyle.value.transform = `translateY(${
          _translateYVal + distanceY
        }px)`;
      }
      // 下移
      if (distanceY > 0) {
        if (_translateYVal > MAX_TOP - 91) {
          return;
        }
        if (distanceY + _translateYVal > MAX_TOP - 91) {
          return;
        }
        popupWrapperStyle.value.transform = `translateY(${
          _translateYVal + distanceY
        }px)`;
      }
    }
  };

  const mouseUp = () => {
    if (distanceY > 0) {
      bodyDown();
    } else {
      bodyGrow();
    }
    distanceY = 0;
    isMouseDown = false;
  };

  const bodyDown = () => {
    popupWrapperStyle.value.transform = `translateY(${popupContentRef.value.scroll.wrapper.clientHeight}px)`;
    popupWrapperStyle.value.transition = `all 0.5s ease-in-out`;
    setTimeout(() => {
      popupWrapperStyle.value.transition = `all 0s ease-in-out`;
    }, 500);
  };

  const bodyGrow = () => {
    popupWrapperStyle.value.transform = "translateY(0px)";
    popupWrapperStyle.value.transition = `all 0.5s ease-in-out`;
    setTimeout(() => {
      popupWrapperStyle.value.transition = `all 0s ease-in-out`;
    }, 500);
  };

  onMounted(() => {
    const _popupHeaderRef = popupHeaderRef.value;
    MAX_TOP.value = popupWrapperRef.value.clientHeight;
    _popupHeaderRef.addEventListener("touchstart", touchStart);
    _popupHeaderRef.addEventListener("touchmove", touchMove);
    _popupHeaderRef.addEventListener("touchend", touchEnd);
    _popupHeaderRef.addEventListener("mousedown", mouseDown);
    _popupHeaderRef.addEventListener("mousemove", mouseMove);
    _popupHeaderRef.addEventListener("mouseup", mouseUp);
    bodyDown();
  });

  return {
    popupHeaderRef,
    popupWrapperRef,
    popupContentRef,
    popupWrapperStyle,
  };
};
</script>

<style lang="scss" scoped>
.live-page {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: #51657d;
  overflow: hidden;
  z-index: 998;
}

.live-detail {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: #51657d;
  overflow: hidden;
  z-index: 998;

  .content-wrapper {
    width: 100%;
    padding-top: 60px;

    .img-wrapper {
      position: relative;
      width: calc(100% - 40px);
      margin: 0 auto;
      height: 280px;
      box-sizing: border-box;
      padding: 9px 13px;
      border-radius: 6px;
      background: #596f7e;

      .holder-img {
        width: 100%;
        height: 100%;
        border-radius: 4px;
      }

      .radio-img {
        position: absolute;
        right: 20px;
        bottom: 16px;
        width: 45px;
        height: 45px;
        border-radius: 50%;
      }

      .click-sum-wrapper {
        position: absolute;
        right: 20px;
        top: 19px;
        padding: 5px 8px;
        background: rgba(134, 140, 146, 0.7);
        color: #ffffff;
        font-size: 12px;
        border-radius: 12px;

        & > span {
          margin-left: 3px;
        }
      }

      .tag-wrapper {
        position: absolute;
        left: 20px;
        top: 19px;
        display: flex;
        align-items: center;

        .tag {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 42px;
          height: 22px;
          background: #e35272;
          border-radius: 6px;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #ffffff;
          margin-right: 5px;
        }
      }
    }

    .progress-wrapper {
      margin-top: 40px;
      width: 100%;
      box-sizing: border-box;
      padding: 0 13px;

      .slider-wrapper {
        display: flex;
        align-items: center;

        .slider-currentTime {
          text-align: left;
          width: 60px;
          font-size: 12px;
          margin-right: 15px;
          color: #fffefe;
        }

        .slider-duratrion {
          text-align: right;
          width: 60px;
          font-size: 12px;
          margin-left: 15px;
          color: #fffefe;
        }
      }
    }

    .options-wrapper {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: #fefefe;
      margin-top: 35px;
      box-sizing: border-box;
      padding: 0 13px;

      .options-wrapper-btn-living {
        color: rgba(254, 254, 254, 0.5);
      }

      .options-wrapper-btn {
        position: relative;
        height: 58px;
        display: flex;
        align-items: center;
        justify-content: center;

        .v-icon-pause-circle,
        .v-icon-play-circle {
          font-size: 58px;
        }

        .v-icon-list,
        .v-icon-play-prev,
        .v-icon-play-next {
          font-size: 22px;
        }

        .v-icon-appoinment {
          font-size: 26px;
        }

        #canvas {
          position: absolute;
          animation: my-rotate infinite 0.8s linear;
        }

        @keyframes my-rotate {
          0% {
            transform: rotate(0deg);
          }

          50% {
            transform: rotate(180deg);
          }

          100% {
            transform: rotate(360deg);
          }
        }

        .options-wrapper-btn-img {
          width: 24px;
          height: 24px;
        }
      }
    }
  }
}

.popup-wrapper {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  top: 140px;
  background: #feffff;
  border-radius: 14px 14px 0 0;
  will-change: transform;
  z-index: 999;

  .popup-holder {
    margin: 5px auto 0;
    width: 36px;
    height: 5px;
    background: #bcbebd;
    border-radius: 3px;
  }

  .notice-swipe {
    width: 100%;
    height: 40px !important;
  }

  .popup-info {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 6px;
    box-sizing: border-box;
    padding: 0 15px;

    .radio-avatar {
      width: 35px;
      height: 35px;
      border-radius: 50%;
      overflow: hidden;
      margin-right: 9px;
      border: 1px solid #e1e6e9;
      box-sizing: border-box;
    }

    .right-content {
      display: flex;
      flex: 1;
      width: 100%;
      flex-direction: column;
      height: 35px;
      justify-content: space-between;
      margin-right: 20px;
      overflow: hidden;

      .content-name {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #000000;
        line-height: 20px;
      }

      .content-program {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #8d8f8e;
        line-height: 17px;
      }
    }

    .right-focus {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 60px;
      min-width: 60px;
      height: 24px;
      background: #465166;
      border-radius: 12px;
      font-size: 14px;
      color: #fdffff;
      font-family: PingFangSC-Regular, PingFang SC;

      .right-focus-icon {
        transform: rotate(45deg) !important;
        margin-right: 5px;
      }
    }

    .right-focus-active {
      background: rgba(70, 81, 102, 0.6);
    }
  }

  .popup-item-wrapper {
    position: relative !important;
    display: flex;
    align-items: center;
    height: 40px;
    width: 100%;

    .popup-item {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 25%;
      height: 100%;

      .popup-item-name {
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #717374;
      }

      .popup-item-name-active {
        font-size: 18px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #2a2c2d;
      }
    }

    .popup-item-solid {
      position: absolute !important;
      bottom: 0;
      left: 0;
      transform: translateX(calc(12.5vw - 10px));
      width: 20px;
      height: 3px;
      background: #f76745 !important;
      border-radius: 2px;
      transition: all 0.3s ease-in-out;
    }
  }

  .popup-content {
    position: absolute;
    bottom: 0;
    top: 91px;
    left: 0;
    right: 0;
    background: #feffff;
    z-index: 999;
    transform: translateZ(99);
    overflow: hidden;
  }
}

.progress-bar-btn {
  text-align: center;
  width: 40px;
  height: 20px;
  line-height: 20px;
  border-radius: 10px;
  background: #fffefe;
  z-index: 2;
  font-size: 12px;
  color: #111;
}

// push页面时：新页面的进入动画
.fold-left-enter-active {
  animation-name: fold-left-in;
  animation-duration: 0.4s;
}

// push页面时：老页面的退出动画
.fold-left-leave-active {
  animation-name: fold-left-out;
  animation-duration: 0.4s;
}

// push页面时：新页面的进入动画
@keyframes fold-left-in {
  0% {
    transform: translate3d(100%, 0, 0);
    /* visibility: visible; */
  }
  100% {
    transform: translate3d(0, 0, 0);
  }
}

// push页面时：老页面的退出动画
@keyframes fold-left-out {
  0% {
    transform: translate3d(0, 0, 0);
  }
  100% {
    transform: translate3d(-100%, 0, 0);
    /* visibility: hidden; */
  }
}

// 后退页面时：即将展示的页面动画
.fold-right-enter-active {
  animation-name: fold-right-in;
  animation-duration: 0.4s;
}

// 后退页面时：后退的页面执行的动画
.fold-right-leave-active {
  animation-name: fold-right-out;
  animation-duration: 0.4s;
}

// 后退页面时：即将展示的页面动画
@keyframes fold-right-in {
  0% {
    width: 100%;
    transform: translate3d(-100%, 0, 0);
    /* visibility: visible; */
  }
  100% {
    width: 100%;
    transform: translate3d(0, 0, 0);
  }
}

// 后退页面时：后退的页面执行的动画
@keyframes fold-right-out {
  0% {
    width: 100%;
    transform: translate3d(0, 0, 0);
  }
  100% {
    width: 100%;
    transform: translate3d(100%, 0, 0);
    /* visibility: hidden; */
  }
}
</style>
